module.exports = __webpack_public_path__ + "static/media/Nunito-Light.6a4fadd2.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/Nunito/Nunito-Light.ttf
// module id = 304
// module chunks = 0